/* Kaufweise Kollektion — ausverkaufte Kacheln global ans Ende.
   Ergaenzt den Liquid-Zwei-Pass (je Seite) fuer Infinite-Scroll/Facet-Reloads.
   Defensiv: reordert nur, wenn ein Sold-out-Item VOR einem verfuegbaren steht. */
(function () {
  'use strict';

  function reorder(grid) {
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.children);
    if (items.length < 2) return;

    var soldSeen = false;
    var needs = false;
    for (var i = 0; i < items.length; i++) {
      var sold = items[i].classList.contains('kw-collection__item--soldout') ||
                 items[i].querySelector('.kw-card--soldout') !== null;
      if (sold) {
        soldSeen = true;
      } else if (soldSeen) {
        needs = true;
        break;
      }
    }
    if (!needs) return;

    var frag = document.createDocumentFragment();
    var soldFrag = document.createDocumentFragment();
    items.forEach(function (li) {
      var sold = li.classList.contains('kw-collection__item--soldout') ||
                 li.querySelector('.kw-card--soldout') !== null;
      (sold ? soldFrag : frag).appendChild(li);
    });
    frag.appendChild(soldFrag);
    grid.appendChild(frag);
  }

  function init(root) {
    var grids = (root || document).querySelectorAll('.kw-collection [ref="grid"], .kw-collection .product-grid');
    grids.forEach(function (grid) {
      reorder(grid);
      if (grid.__kwObserved) return;
      grid.__kwObserved = true;
      var scheduled = false;
      var mo = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          reorder(grid);
        });
      });
      mo.observe(grid, { childList: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
})();
